<template>
  <q-page class="">
    <div class="q-pa-md q-gutter-sm">
      <q-breadcrumbs>
        <q-breadcrumbs-el label="dashboard" icon="dashboard" to="/app/" />
        <q-breadcrumbs-el :label="labelCurrent" icon="build" :to="linkCurrent" />
      </q-breadcrumbs>
    </div>
    <div class="q-pa-md q-gutter-sm">
      <q-banner class="text-white bg-red" v-if="!(seance.opened && seance.running)">
        <template v-slot:avatar>
          <q-icon name="warning" color="white" />
        </template>
        La séance n'est pas ou plus en cours. Vous ne pouvez donc pas effectuer de commandes pour le moment.
      </q-banner>
    </div>
    <section class="row justify-around items-start">
      <div class="row items-center">
        <div class="grid grid-cols-3 grid-gap-4">
          <template v-for="category in categories">
            <q-card :key="category.id" >
              <div>
                <p class="text-capitalize text-weight-medium text-center q-mb-none q-py-xs">{{ category.name }}</p>
              </div>
              <q-separator />
              <q-markup-table  >
                <tbody>
                  <tr v-for="boisson in boissons" :key="boisson.id" cypress="drinkList" class="table-row" v-if="boisson.category.id == category.id">
                    <td class="text-left text-capitalize text-weight-medium" >{{boisson.name}}</td>
                    <td class="text-right" >{{boisson.optimized_price}} €</td>
                    <td class="text-right row items-center">
                      <q-input type="number" v-model.number="boisson.quantite" value="0"/>
                      <div class="column">
                        <q-btn 
                          class="q-mb-sm"
                          color="primary" 
                          icon="fa fa-caret-up"
                          @click="increase(boisson.id)" />
                        <q-btn
                          class=""
                          color="primary"
                          icon="fa fa-caret-down"
                          @click="decrease(boisson.id)"/>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </q-markup-table>
            </q-card>
          </template>
        </div>
        <div class="colum justify-around q-ml-md">
          <q-card class="q-pa-md">
            <div class="row justify-around items-center">
              <div>
                <p>Total :</p>
              </div>
              <div>
                <p class="">{{total.nbrConso}} consos</p>
                <p class="">{{total.prix}} €</p>
              </div>
            </div>
            <q-btn 
              class="q-pa-md q-mt-md"
              color="secondary" 
              label="Commander"
              size="xl"
              :disabled="!(seance.opened && seance.running) || total.nbrConso === 0"
              @click="validate = true"/>
            <div class="q-mt-md">
              <p class="text-center">Ventes totales sur la soirée:</p>
              <p class="text-center"> {{totalPrice}}€</p>
            </div>
             
          </q-card>

          
        </div>
      </div>
    </section>
    <Commande 
      :show="validate"
      :commande="boissons"
      :totaux="total"
      :requiredPaymentMethod="requiredPaymentMethod"
      @cancel="validate = false"
      @validate="envoyer"/>
  </q-page>
</template>
<script>
import { mapState } from 'vuex';
import ReconnectingEventSource from "reconnecting-eventsource";
import { getSeanceById, getTotalPriceBySeance } from '~/services/seances';
import { createCommande } from '~/services/drinks';
import Commande from '~/components/Commande.vue';
import { baseUrl, base_url_seances } from '~/variables';

export default {
  name: 'LiveSeance',
  components: {
    Commande
  },
  data() {
    return {
      currentSeanceId: this.$route.params.id,
      boissons: [],
      seance: {},
      categories: [],
      validate: false,
      totalPrice: 0,
      es: null
    };
  },
  async created() {
    const response = await getSeanceById(this.currentSeanceId);
    this.seance = response.data
    this.boissons = response.data.drinks;
    this.boissons = this.boissons.map( (e) => {
      // si la category existe déjà, on ajoute la boisson à la catégory
      if(this.categories.filter(elCat => {
        return elCat.name === e.category.name && elCat.id === e.category.id
      }).length == 0) {
        this.categories.push({...e.category})
      }
      e.start_price = Number.parseFloat(e.start_price).toFixed(2)
      e.current_price = Number.parseFloat(e.current_price).toFixed(2)
      e.optimized_price = Number.parseFloat(e.optimized_price).toFixed(2)
      e.lower_price = Number.parseFloat(e.lower_price).toFixed(2)
      e.higher_price = Number.parseFloat(e.higher_price).toFixed(2)
      return e = {...e, ...{quantite: 0}}
    })
    const resp = await getTotalPriceBySeance(this.currentSeanceId)
    this.totalPrice = Number.parseFloat(resp.data.total_price).toFixed(2)
  },
  mounted() {
    this.setupStream();
  },
  destroyed () {
    this.es.close()
  },
  methods: {
    setupStream() {
      // Not a real URL, just using for demo purposes
      this.es = new ReconnectingEventSource(`${baseUrl}${base_url_seances}/${this.currentSeanceId}/events/`);
      let alertDeco = this.alertDeco
      this.es.onerror = function(e) {
        alertDeco()
      };
      this.es.addEventListener('update', event => {
        let data = JSON.parse(event.data);
        data.map( e => {
          const index =  this.boissons.findIndex(e1 => e1.id === e.drink.id);
          let boisson = {...e.drink, ...{quantite: this.boissons[index].quantite}}
          return this.$set(this.boissons, index, boisson)
        });
      }, false);
      this.es.addEventListener('total_price', event => {
        let data = JSON.parse(event.data);
        this.totalPrice = data.total_price.toFixed(2);
      }, false);
    },
    increase(id) {
      let boisson = this.boissons.filter(e => e.id === id)[0];
      boisson.quantite += 1;
    },
    alertDeco() {
      this.$q.notify({
        color: 'red-4',
        textColor: 'white',
        icon: 'fas fa-check-circle',
        message: 'Vous êtes déconnecté du serveur BarTradingX',
        position: 'top-right'
      });
    },
    decrease(id) {
      let boisson = this.boissons.filter(e => e.id === id)[0];
      if ( !(boisson.quantite - 1 < 0)) {
        boisson.quantite -= 1;
      }
    },
    async envoyer(command) {
      this.validate = false;
      let consommations = command.drinks.filter(e => e.quantite > 0);
      if (consommations.length > 0) {
        consommations = consommations.map(e => {
          return {
            price: e.optimized_price,
            quantite: e.quantite, 
            drink_id: e.id
          }
        })
        let commande = {
          waiter: this.user.id,
          seance: this.currentSeanceId,
          consommation_set: consommations,
          payment_method: command.paymentMethod,
        }
        const resp = await createCommande(commande);
        if (resp.status === 201) {
          this.$q.notify({
            color: 'green-4',
            textColor: 'white',
            icon: 'fas fa-check-circle',
            message: 'Commande passée',
            position: 'top-right'
          });
          this.boissons = this.boissons.map(e => {
              delete e['quantite']
              return e = {...e, ...{quantite: 0}}
            })
        } else {
          this.$q.notify({
            color: 'red-4',
            textColor: 'white',
            icon: 'fas fa-check-circle',
            message: 'Imposible de passer une commande',
            position: 'top-right'
          });
        }
      } else {
        this.$q.notify({
            color: 'red-4',
            textColor: 'white',
            icon: 'fas fa-exclamation-circle',
            message: 'Veuilez ajouter au moins un boisson',
            position: 'top-right'
          });
      }
      
    }
  },
  computed: {
    linkCurrent() {
      return `/app/live_seance/${this.currentSeanceId}`;
    },
    labelCurrent() {
      if (!this.seance) {
        return `seance `
      }
      return `Seance ${this.seance.code_acces}`;
    },
    requiredPaymentMethod() {
      if (this.seance) {
        return this.seance.need_payment_method
      }
      return false
    },
    total() {
      let totalObject = { 
        prix: 0, 
        nbrConso: 0
      };
      if ( this.boissons.length > 0 ) {
        let totalPrice = 0;
        let totalQuantite = 0;
        for (let i = 0; i < this.boissons.length; i++ ) {
          totalPrice += this.boissons[i].quantite * this.boissons[i].optimized_price;
          totalQuantite += this.boissons[i].quantite;
        }
        totalObject = { 
          prix: Number.parseFloat(totalPrice).toFixed(2), 
          nbrConso: totalQuantite
        };
      }
      return totalObject;
    },
    ...mapState({
      user: state => state.user.user,
    })
  }
};
</script>
<style lang="scss" scoped>
.table-row {
  td {
    height: 102px;
    font-size: 110%;

    .q-input {
      width: 45px;
    }
  }
}
</style>